import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bdea604"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer bg-dark no-print" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "container my-4 d-flex flex-wrap justify-content-sm-around" }
const _hoisted_4 = {
  key: 0,
  class: "col-12 col-sm-auto px-4 py-1"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h5" }, "Customer Support", -1))
const _hoisted_6 = { class: "list-unstyled mb-0" }
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h5" }, "Terms", -1))
const _hoisted_9 = { class: "list-unstyled mb-0" }
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1))
const _hoisted_12 = { class: "container my-4" }
const _hoisted_13 = { class: "col-12 text-center" }
const _hoisted_14 = { class: "small" }
const _hoisted_15 = ["href"]

import brand from "@/brand";

export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("footer", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(brand).whatsapp)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("ul", _hoisted_6, [
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    class: "d-inline-flex align-items-center",
                    target: "_blank",
                    href: `https://wa.me/${_unref(brand).whatsapp}`
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "pe-2 fs-5",
                      icon: "fa-brands fa-whatsapp"
                    }),
                    _createTextVNode(" " + _toDisplayString(_unref(brand).whatsappLabel), 1)
                  ], 8, _hoisted_7)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["col-12 col-sm-auto px-4 py-1", { 'mt-3 mt-sm-0': _unref(brand).whatsapp }])
        }, [
          _hoisted_8,
          _createElementVNode("ul", _hoisted_9, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: _unref(brand).termsUrl,
                target: "_blank"
              }, "Terms & Conditions", 8, _hoisted_10)
            ])
          ])
        ], 2)
      ]),
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createTextVNode("© " + _toDisplayString(new Date().getFullYear()) + ", ", 1),
            _createElementVNode("a", {
              href: _unref(brand).siteUrl,
              target: "_blank"
            }, _toDisplayString(_unref(brand).name), 9, _hoisted_15)
          ])
        ])
      ])
    ])
  ]))
}
}

})